import { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import ReactRecaptcha3 from 'react-google-recaptcha3'
import Field from '../components/form/Field.jsx'
import Button from '../components/Button.jsx'
import { CreateGdprDeleteUser, ExecuteGdprDeleteUser } from '../repo/UsersRepo.js'
import { AuthContext } from '../store/auth-context.js'
import { config } from '../config';

function GdprDeleteUserPage() {
  const authCtx = useContext(AuthContext)
  const [password, setPassword] = useState('')
  const [gdprDeleteToken, setGdprDeleteToken] = useState('')
  const [requestError, setRequestError] = useState('')
  const [requestSuccess, setRequestSuccess] = useState('')
  const [tokenError, setTokenError] = useState('')
  const [isRequesting, setIsRequesting] = useState(false)
  const [isExecuting, setIsExecuting] = useState(false)
  const [completed, setCompleted] = useState(false)

  useEffect(() => {
    ReactRecaptcha3.init(config.recaptchaPublicKey).then(status => {
      if (status !== 'success') {
        console.log("Error! Could not load Recaptcha.")
      }
    })
  }, [])

  async function handleRequestToken(e) {
    e.preventDefault()

    if (password.trim() === '') {
      return
    }

    setRequestError('')
    setRequestSuccess('')
    setIsRequesting(true)

    const recaptchaToken = await getRecaptchaToken()

    try {
      const response = await CreateGdprDeleteUser(password, recaptchaToken)

      if (response.status === 204) {
        setRequestSuccess('Enviamos um email para você com o token para você copiar e colar no formulário abaixo e concluir o processo.')
      } else if (response.status === 403) {
        setRequestError('Credenciais inválidas')
      } else {
        setRequestError('Erro ao validar sua conta, tente novamente mais tarde')
      }
    } catch {
      setRequestError('Erro ao validar sua conta, tente novamente mais tarde')
    }

    setIsRequesting(false)
  }

  async function handleExecuteDelete(e) {
    e.preventDefault()

    if (gdprDeleteToken.trim() === '') {
      return
    }

    setTokenError('')
    setIsExecuting(true)

    try {
      const response = await ExecuteGdprDeleteUser(gdprDeleteToken)

      if (response.status === 204) {
        authCtx.logout()
        setCompleted(true)
      } else {
        setTokenError('Token inválido')
      }
    } catch {
      setTokenError('Token inválido')
    }

    setIsExecuting(false)
  }

  if (completed) {
    return (
      <section>
        <div className="container mx-auto flex flex-col items-center justify-between lg:w-6xl">
          <div id="alert-additional-content-3" className="p-4 m-8 text-green-800 border border-green-300 rounded-lg bg-green-50" role="alert">
            <div className="flex items-center">
              <svg className="shrink-0 w-4 h-4 me-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
              </svg>
              <span className="sr-only">Info</span>
              <h3 className="text-lg font-medium">O processo foi iniciado e em pouco tempo todos seus dados serão excluídos.</h3>
            </div>
          </div>

          <Link className="font-medium text-green-600 hover:underline" to={"/"}>Voltar</Link>
        </div>
      </section>
    )
  }

  return (
    <section>
      <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <h1 className="flex items-center lg:mt-24 mb-6 text-2xl font-semibold text-gray-900">
          Excluir Conta
        </h1>
        <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
            <form className="space-y-4 md:space-y-6" onSubmit={handleRequestToken}>
              <p className="text-sm text-gray-700">
                <b className="pr-2">Passo 1:</b>
                Confirme sua senha para receber por email o token de exclusão dos seus dados.
              </p>
              <Field type={"password"} name={"password"} id={"password"} label={"Senha"} value={password} onChange={e => setPassword(e.target.value)} disabled={isRequesting} error={requestError}/>
              <Button styleName="green" className="w-full" disabled={isRequesting || password.trim() === ''}>
                {isRequesting ? 'Enviando...' : 'Solicitar token'}
              </Button>
              {requestSuccess && (
                <div className="p-4 text-green-800 border border-green-300 rounded-lg bg-green-50" role="alert">
                  <span className="text-sm font-medium">{requestSuccess}</span>
                </div>
              )}
            </form>

            <hr className="border-gray-200"/>

            <form className="space-y-4 md:space-y-6" onSubmit={handleExecuteDelete}>
              <p className="text-sm text-gray-700">
                <b className="pr-2">Passo 2:</b>
                Cole abaixo o token que você recebeu por email para concluir o processo.
              </p>
              <Field type={"input"} name={"gdpr_delete_token"} id={"gdpr_delete_token"} label={"Token"} value={gdprDeleteToken} onChange={e => setGdprDeleteToken(e.target.value)} disabled={isExecuting} error={tokenError}/>
              <Button styleName="red" className="w-full" disabled={isExecuting || gdprDeleteToken.trim() === ''}>
                {isExecuting ? 'Excluindo...' : 'Excluir meus dados'}
              </Button>
            </form>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GdprDeleteUserPage

async function getRecaptchaToken() {
  let recaptchaToken = '';

  await ReactRecaptcha3.getToken().then(token => {
    recaptchaToken = token
  }, error => {
    console.log("ERROR!", error)
  })

  return recaptchaToken;
}
